import { PaymentMethodChoosingStrategy, PaymentMethod } from "src/@types/paymentMethods";
import { exhaustiveMatchGuard } from "./exhaustive";


export const getAllowedPaymentMethods = (strategy: PaymentMethodChoosingStrategy): PaymentMethod[] => {
  switch (strategy) {
    case PaymentMethodChoosingStrategy.CardOnly: return ["Card"];
    case PaymentMethodChoosingStrategy.InvoiceRecommended: return ["Invoice", "Card"];
    case PaymentMethodChoosingStrategy.InvoiceOnly: return ["Invoice"];
    // If you are getting a type error here, there is a missing "case" in this "switch"
    default: exhaustiveMatchGuard(strategy)
  }

}

export const getPaymentProviderForPaymentMethod = (method: PaymentMethod): string => {
  switch (method) {
    case "Card": return "STRIPE"
    case "Invoice": return "INVOICE"
    // If you are getting a type error here, there is a missing "case" in this "switch"
    default: exhaustiveMatchGuard(method)
  }

}
